module.exports = __webpack_public_path__ + "img/handover.996e6700.svg";